import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ClientsPages from "../components/Clients";

const ClientsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Clients" />

        {/* DashBoardLayerTwo */}
        <ClientsPages />

      </MasterLayout>
    </>
  );
};

export default ClientsPage;
